import React from 'react';
import {Switch} from "antd";

const IpSettings = () => {
    const onChange = () => {
      
    }
    return (
        <div className="ip-settings main-padding">
            <div className="camera-config-header">
                <span>Home</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>System Management</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>IP Settings</span>
            </div>

            <div className="camera-config-content">
                <h6 className="alert-title-cmcf">
                    If you modify an IP address, subnet mask, gateway, or Web port, the software will restart!
                </h6>

                <div className="my-avform mt-4">

                    <div className="row">
                        <div className="col-md-2 text-end text-white">Automatically Get The DNS </div>
                        <div className="col-md-4">   <Switch defaultChecked onChange={onChange} /></div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end">
                            <label  className="text-white">
                                IP Address
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input type="text" className="w-100 p-2"/>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-2 text-end">
                            <label  className="text-white">
                                Subnet Mask
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input type="text" className="w-100 p-2"/>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-2 text-end">
                            <label  className="text-white">
                                Gateway
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input type="text" className="w-100 p-2"/>
                        </div>
                    </div>
                </div>
                <div className="my-avform mt-5">

                    <div className="row">
                        <div className="col-md-2 text-end text-white">Automatically Get The DNS </div>
                        <div className="col-md-4">   <Switch defaultChecked onChange={onChange} /></div>
                    </div>
                   <div className="col-md-2 text-end">
                       <h5 className="text-white mt-3 mb-3">
                           Server Address
                       </h5>
                   </div>
                    <div className="row">
                        <div className="col-md-2 text-end">
                            <label  className="text-white">
                                First DNS
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input type="text" className="w-100 p-2"/>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-2 text-end">
                            <label  className="text-white">
                                Second DNS
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input type="text" className="w-100 p-2"/>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-2 text-end">
                            <label  className="text-white">
                                MAC
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input type="text" className="w-100 p-2"/>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-2 text-end">
                            <label  className="text-white">
                                Web Port
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input type="text" className="w-100 p-2"/>
                        </div>
                    </div>
                 <div className="offset-2 col-md-4 mt-3">
                     <button className="btn btn-primary">SET</button>
                 </div>
                </div>
            </div>
        </div>
    );
};

export default IpSettings;